import fetch$1 from 'cross-fetch';
import { isObject } from 'lodash';
import * as qs from 'query-string';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

const validateUserInfo = (props = {}) => {
  let valid = true;
  let reason = '';
  const {
    visitorId,
    userId
  } = props || {};

  switch (true) {
    case !visitorId && !userId:
      {
        valid = false;
        reason = '[XS] `vistorId` & `userId is missing. Please provide either or both';
        break;
      }
  }

  return {
    valid,
    reason
  };
};

const CONTENT_TYPE = 'Content-Type';
const APPLICATION_JSON = 'application/json';
function fetch (url, options = {}) {
  const {
    params,
    body,
    headers = {}
  } = options,
        requestOptions = __rest(options, ["params", "body", "headers"]);

  const hasBody = body && isObject(options.body);
  const finalBody = hasBody ? JSON.stringify(body) : body;
  const finalHeaders = hasBody ? Object.assign(Object.assign({}, headers), {
    [CONTENT_TYPE]: APPLICATION_JSON
  }) : headers;
  const finalUrl = params ? `${url}?${qs.stringify(params)}` : url;
  return fetch$1(finalUrl, Object.assign(Object.assign({}, requestOptions), {
    body: finalBody,
    headers: finalHeaders
  }));
}

function getOptions(method, options = {}) {
  const {
    body
  } = options,
        extra = __rest(options, ["body"]);

  const requestOptions = Object.assign({
    method
  }, extra);

  if (body) {
    Object.assign(requestOptions, {
      body
    });
  }

  return requestOptions;
}

const serviceCaller = baseUrl => ({
  get: (path, options) => __awaiter(void 0, void 0, void 0, function* () {
    const requestOptions = getOptions('GET', options);
    const response = yield fetch(baseUrl + path, requestOptions);
    if (!response.ok) throw response;
    const data = yield response.json();
    return data;
  }),
  put: (path, options) => __awaiter(void 0, void 0, void 0, function* () {
    const requestOptions = getOptions('PUT', options);
    const response = yield fetch(baseUrl + path, requestOptions);
    if (!response.ok) throw response;
    const data = yield response.json();
    return data;
  }),
  patch: (path, options) => __awaiter(void 0, void 0, void 0, function* () {
    const requestOptions = getOptions('PATCH', options);
    const response = yield fetch(baseUrl + path, requestOptions);
    if (!response.ok) throw response;
    const data = yield response.json();
    return data;
  }),
  post: (path, options) => __awaiter(void 0, void 0, void 0, function* () {
    const requestOptions = getOptions('POST', options);
    const response = yield fetch(baseUrl + path, requestOptions);
    if (!response.ok) throw response;
    const data = response.status === 204 ? {} : yield response.json();
    return data;
  })
});

const fetchAllFeatures = props => __awaiter(void 0, void 0, void 0, function* () {
  try {
    const {
      baseUrl
    } = props;
    const fetcher = serviceCaller(baseUrl);
    const path = '/xs-edge/v1/features/all?active=true';
    const res = yield fetcher.get(path, {});
    return res;
  } catch (e) {
    console.error('[XS] *************Unable to load all Features*************');
    throw e;
  }
});
const fetchUserFeatures = props => __awaiter(void 0, void 0, void 0, function* () {
  try {
    const {
      baseUrl,
      user,
      context
    } = props;
    const fetcher = serviceCaller(baseUrl);
    let params = user;
    const path = '/xs-edge/v1/features';

    if (context) {
      params = Object.assign(Object.assign({}, params), context);
    }

    const res = yield fetcher.get(path, {
      params
    });
    return res;
  } catch (e) {
    console.error("[XS] *************Unable to load user's Features*************");
    throw e;
  }
});
const exposeFeature = props => __awaiter(void 0, void 0, void 0, function* () {
  try {
    const {
      baseUrl,
      payload
    } = props;
    const fetcher = serviceCaller(baseUrl);
    const path = '/xs-edge/v1/features/exposures';
    yield fetcher.post(path, {
      body: payload
    });
  } catch (e) {
    console.error('[XS] *************Unable to expose Features*************');
    throw e;
  }
});

var XSEvents;

(function (XSEvents) {
  XSEvents["PRE_FEATURES_LOAD"] = "PRE_FEATURES_LOAD";
  XSEvents["POST_FEATURES_LOAD"] = "POST_FEATURES_LOAD";
  XSEvents["PRE_EXPOSURE"] = "PRE_EXPOSURE";
  XSEvents["POST_EXPOSURE"] = "POST_EXPOSURE";
})(XSEvents || (XSEvents = {}));

class EventEmitter {
  constructor() {
    this.events = {};

    this.emit = (name, ...args) => {
      const events = this.events[name];

      if (events && events.length > 0) {
        for (const cb of events) {
          cb(...args);
        }
      }
    };

    this.on = (name, cb) => {
      if (!this.events[name]) {
        this.events[name] = [];
      }

      this.events[name].push(cb);
    };
  }

}

class PluginManager extends EventEmitter {
  constructor(props) {
    super();

    this.registerEvents = () => {
      this.plugins.forEach(plugin => {
        if (plugin.beforeFeaturesLoad) {
          this.on(XSEvents.PRE_FEATURES_LOAD, plugin.beforeFeaturesLoad);
        }

        if (plugin.beforeExposure) {
          this.on(XSEvents.PRE_EXPOSURE, plugin.beforeExposure);
        }

        if (plugin.onFeaturesLoad) {
          this.on(XSEvents.POST_FEATURES_LOAD, plugin.onFeaturesLoad);
        }

        if (plugin.onExposure) {
          this.on(XSEvents.POST_EXPOSURE, plugin.onExposure);
        }
      });
    };

    this.plugins = props.plugins || [];
    this.registerEvents();
  }

}

const validateContext = props => {
  let valid = true;
  let reason = '';
  const {
    locale
  } = props || {};

  switch (true) {
    case !locale:
      {
        valid = false;
        reason = '[XS] `locale` is missing.';
        break;
      }
  }

  return {
    valid,
    reason
  };
};

const WW_BROWSER_ID = 'ww_browser_id';
const ReadySuccessEvent = {
  success: true,
  message: 'XS instance is ready'
};
const ReadyTimoutEvent = {
  success: false,
  reason: 'timeout',
  message: 'XS instance timed out'
};

class XS {
  constructor(props) {
    this.exposedFeatures = {};
    this.ready = false;
    this.features = {};
    this.rawFeatures = {
      experiments: [],
      flags: []
    };
    this.allFeatures = {
      experiments: [],
      flags: []
    };
    this.normalizedAllFeatures = {};
    /**
     * Method to default to empty features. So that the instance is ready.
     * This helps incase the instacne failed to load features, we don't want to break the clients of the SDK or throw errors.
     *
     * @function defaultToEmptyFeatures
     * @private
     * @returns void
     */

    this.defaultToEmptyFeatures = () => {
      this.rawFeatures = {
        experiments: [],
        flags: []
      };
      this.features = {};
      this.allFeatures = {
        experiments: [],
        flags: []
      };
      this.normalizedAllFeatures = {};
      this.isReadyPromiseResolver(ReadySuccessEvent);
    };
    /**
     * Set a feature as exposed
     *
     * @function setExposure
     * @returns adds the feature to the exposed features
     */


    this.setExposure = featureId => {
      this.exposedFeatures[featureId] = true;
    };
    /**
     * Check if a feature is aleady exposed
     *
     * @function getExposure
     * @returns returns true if the feature is exposed
     */


    this.getExposure = featureId => {
      return this.exposedFeatures[featureId];
    };
    /**
     * Get promise that resolves when the instance is ready
     *
     * @function onReady
     * @returns a promise that resolves when the instance is ready
     */


    this.onReady = () => {
      let timeoutId;
      const timeoutPromise = new Promise(resolve => {
        timeoutId = setTimeout(() => {
          resolve(ReadyTimoutEvent);
        }, this.timeout);
      });
      return Promise.race([this.isReadyPromise, timeoutPromise]).then(event => {
        clearTimeout(timeoutId);
        this.ready = event.success;

        if (!event.success) {
          console.warn('[XS] XS instance failed to get ready in the given time. Defaulting to empty features.');
          this.defaultToEmptyFeatures();
        }

        return event;
      });
    };

    this.isInstanceReady = () => {
      return this.ready;
    };
    /**
     * Check if the instance has valid featuress
     *
     * @function  hasValidFeatures
     * @returns true if the instance has valid featuress
     */


    this.hasValidFeatures = () => {
      return this.rawFeatures.experiments.length > 0 || this.rawFeatures.flags.length > 0;
    };
    /**
     * Sets the user for the XS instance.
     * If user features are already loaded, then the instance ready promise will be resolved.
     *
     * @function setUser
     * @param user - user details
     * @returns void
     */


    this.setUser = user => {
      if (user) {
        const {
          valid,
          reason
        } = validateUserInfo(user);

        if (!valid) {
          console.warn('[XS] User info is invalid: ', reason);
          console.warn('[XS] Instance will not fetch features or register exposure until valid user info is provided');
          return;
        }

        this.user = user;

        if (this.hasValidFeatures() && this.context) {
          this.isReadyPromiseResolver(ReadySuccessEvent);
        }
      }
    };

    this.setContext = context => {
      if (context) {
        const {
          valid,
          reason
        } = validateContext(context);

        if (!valid) {
          console.warn('[XS] Context is invalid: ', reason);
          console.warn('[XS] Instance will not fetch features or register exposure until valid context is provided');
          return;
        }

        this.context = context;

        if (this.hasValidFeatures() && this.user) {
          this.isReadyPromiseResolver(ReadySuccessEvent);
        }
      }
    };
    /**
     * Loads user features.
     * If the user prop is already set, then the instance ready promise will be resolved
     *
     * @function loadFeatures
     * @param features - raw user features
     * @returns Normalized user features
     */


    this.loadFeatures = features => {
      this.pluginsManager.emit(XSEvents.PRE_FEATURES_LOAD);
      this.rawFeatures = features;
      this.features = XS.normalizeUserFeatures(this.rawFeatures);

      if (this.user && this.context) {
        this.isReadyPromiseResolver(ReadySuccessEvent);
      }

      this.pluginsManager.emit(XSEvents.POST_FEATURES_LOAD);
      return this.features;
    };

    this.loadNormalizedFeatures = features => {
      this.pluginsManager.emit(XSEvents.PRE_FEATURES_LOAD);
      this.features = features;

      if (this.user && this.context) {
        this.isReadyPromiseResolver(ReadySuccessEvent);
      }

      this.pluginsManager.emit(XSEvents.POST_FEATURES_LOAD);
      return this.features;
    };
    /**
     * Get the feature for a given feature id.
     *
     * @function getFeature
     * @param id -  feature id
     * @returns The mapped user feature details.
     */


    this.getFeature = id => {
      return this.features[id];
    };
    /**
     * Get all of the user features without normalization.
     *
     * @function getRawUserFeatures
     * @returns raw user features
     */


    this.getRawUserFeatures = () => {
      return this.rawFeatures;
    };
    /**
     * Get the bucketed variation name for a given feature id.
     *
     * @function getVariation
     * @param id - feature id
     * @returns
     */


    this.getVariation = id => {
      var _a;

      return (_a = this.features[id]) === null || _a === void 0 ? void 0 : _a.variationName;
    };
    /**
     * Get the bucketed variation attributes for a given feature id.
     *
     * @function getAttributes
     * @param id - feature id
     * @returns Mapped variation attributes
     */


    this.getAttributes = id => {
      var _a;

      return (_a = this.features[id]) === null || _a === void 0 ? void 0 : _a.attributes;
    };
    /**
     * Get the bucketed variation attribute for a given feature id & attribute name.
     *
     * @function getAttribute
     * @param id - feature id
     * @returns value of the mapped attribute
     */


    this.getAttribute = (id, attributeName) => {
      var _a, _b;

      return (_b = (_a = this.features[id]) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b[attributeName];
    };
    /**
     * Fetch bucketed user features, variation and attributes.
     * Sets & resolves with default values when the API call fails.
     * This decreased the chances of unhandled promise rejections for the SDK users.
     *
     * @function fetchAllFeatures
     * @returns normalized user features
     */


    this.fetchUserFeatures = () => __awaiter(this, void 0, void 0, function* () {
      if (!this.user) {
        console.warn('[XS] No user set. Defaulting to empty features.');
        this.defaultToEmptyFeatures();
        return this.features;
      }

      if (!this.context) {
        console.warn('[XS] No context set. Defaulting to empty features.');
        this.defaultToEmptyFeatures();
        return this.features;
      }

      try {
        this.pluginsManager.emit(XSEvents.PRE_FEATURES_LOAD);
        this.rawFeatures = yield XS.fetchUserFeatures(this.baseUrl, this.user, this.context);
        this.features = XS.normalizeUserFeatures(this.rawFeatures);
        this.isReadyPromiseResolver(ReadySuccessEvent);
        this.pluginsManager.emit(XSEvents.POST_FEATURES_LOAD);
        return this.features;
      } catch (e) {
        console.error('[XS] Failed to fetch user features', e);
        this.defaultToEmptyFeatures();
        return this.features;
      }
    });
    /**
     * Fetch bucketed user features, variation and attributes.
     * Resolves with empty object when the API call fails.
     * This decreased the chances of unhandled promise rejections for the SDK users.
     *
     * @function fetchFeatures
     * @returns normalized features
     */


    this.fetchFeatures = () => __awaiter(this, void 0, void 0, function* () {
      try {
        this.allFeatures = yield XS.fetchFeatures(this.baseUrl);
        this.normalizedAllFeatures = XS.normalizeFeatures(this.allFeatures);
        return this.normalizedAllFeatures;
      } catch (e) {
        console.error('[XS] Failed to fetch user features', e);
        return {};
      }
    });
    /**
     * Register Exposure for a given feature id.
     * If the feature is not found in the instance map, then exposure is skipped.
     * If the feature is already exposed, then exposure is skipped.
     * If the exposure was successful, then the feature is marked as exposed in the internal cache.
     * Resolves even if the API call fails.
     *
     * @function fetchFeatures
     * @returns normalized features
     */


    this.exposeFeature = id => __awaiter(this, void 0, void 0, function* () {
      try {
        if (!this.user) {
          console.warn('[XS] No user set. Aborting feature exposure.');
          return;
        }

        const feature = this.features[id];

        if (!feature) {
          console.warn(`[XS] No feature found for id: ${id}. Skipping exposure.`);
          return;
        }

        const isAlreadyExposed = this.getExposure(id);

        if (isAlreadyExposed) {
          console.warn(`[XS] Feature ${id} already exposed. Skipping exposure.`);
          return;
        }

        this.pluginsManager.emit(XSEvents.PRE_EXPOSURE, feature);
        const {
          featureId,
          variationId
        } = this.features[id];

        if (!variationId) {
          console.warn(`[XS] Feature ${id} has no variationId. Skipping exposure.`);
          return;
        }

        yield XS.exposeFeature(this.baseUrl, Object.assign(Object.assign({}, this.user), {
          featureId,
          variationId
        }));
        this.pluginsManager.emit(XSEvents.POST_EXPOSURE, feature);
        this.setExposure(id);
      } catch (e) {
        console.error('[XS] Failed to expose feature', e);
      }
    });

    const {
      baseUrl = 'https://api.ww.com',
      features,
      normalizedFeatures,
      user,
      context,
      timeout = 3000
    } = props || {}; // eslint-disable-next-line @typescript-eslint/no-empty-function

    this.isReadyPromiseResolver = () => __awaiter(this, void 0, void 0, function* () {});

    this.isReadyPromise = new Promise(resolve => {
      this.isReadyPromiseResolver = resolve;
    });
    this.baseUrl = baseUrl;
    this.timeout = timeout;
    this.pluginsManager = new PluginManager({
      plugins: props === null || props === void 0 ? void 0 : props.plugins
    });
    this.setUser(user);
    this.setContext(context);

    if (normalizedFeatures) {
      this.loadNormalizedFeatures(normalizedFeatures);
    }

    if (features) {
      try {
        this.loadFeatures(features);
      } catch (_a) {
        this.defaultToEmptyFeatures();
      }
    }
  }

  static fetchUserFeatures(baseUrl, user, context) {
    return __awaiter(this, void 0, void 0, function* () {
      const data = yield fetchUserFeatures({
        baseUrl,
        user,
        context
      });
      return data;
    });
  }

  static fetchFeatures(baseUrl) {
    return __awaiter(this, void 0, void 0, function* () {
      const data = yield fetchAllFeatures({
        baseUrl
      });
      return data;
    });
  }

  static exposeFeature(baseUrl, payload) {
    return __awaiter(this, void 0, void 0, function* () {
      yield exposeFeature({
        baseUrl,
        payload
      });
    });
  }

  static getCookieName() {
    return WW_BROWSER_ID;
  }

  static normalizeUserFeatures(data) {
    const {
      experiments,
      flags
    } = data;
    return [...experiments, ...flags].reduce((accu, feature) => {
      var _a;

      const {
        id: featureId,
        text_id: featureTextId,
        variation_id: variationId,
        variation_name: variationName,
        value: featureValue
      } = feature;
      const attributes = (_a = feature.attributes) === null || _a === void 0 ? void 0 : _a.reduce((accu, attribute) => {
        const {
          name,
          value
        } = attribute;
        accu[name] = value;
        return accu;
      }, {});
      accu[featureTextId] = {
        featureId,
        featureTextId,
        featureValue
      };

      if (variationId) {
        accu[featureTextId].variationId = variationId;
      }

      if (variationName) {
        accu[featureTextId].variationName = variationName;
      }

      if (attributes) {
        accu[featureTextId].attributes = attributes;
      }

      return accu;
    }, {});
  }

  static normalizeFeatures(data) {
    const {
      experiments,
      flags
    } = data;
    return [...experiments, ...flags].reduce((accu, feature) => {
      const {
        id,
        text_id: textId,
        name,
        enabled
      } = feature;
      const variations = feature.variations.reduce((accu, variation) => {
        const {
          name
        } = variation;
        const attributes = variation.attributes.reduce((accu, attribute) => {
          const {
            name
          } = attribute;
          accu[name] = attribute;
          return accu;
        }, {});
        accu[name] = Object.assign(Object.assign({}, variation), {
          attributes
        });
        return accu;
      }, {});
      accu[textId] = {
        id,
        textId,
        name,
        enabled,
        variations
      };
      return accu;
    }, {});
  }

}

XS.validateUserInfo = validateUserInfo;

export { XS as default };
